import React,{useState} from 'react'
import { Form, Input, Button, Checkbox, message } from 'antd';
import styled from 'styled-components'
// import { Row, Col } from 'antd';
import { fetchLogin,forgetPassword } from '../api/authSlice'
import {  useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  const tailLayout = {
    wrapperCol: { offset: 5, span: 19 },
  };
  


export default function Login() {

  const dispatch = useDispatch()
  const [isemail,setEmail] = useState(null)
  const [visibleEmail, setEmailModal] = useState(false);

  console.log(isemail);
    const onFinish = values => {

         dispatch(fetchLogin(values))
        
     
      };
    
      const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
      };
     
      const handleChange = (e) =>{

        if(e.target.value.length>0)
        {
        setEmail(e.target.value)
        } 
        else{
          setEmail(null)
        }
    }


    
    const handleClickEmail = () =>{
      if(!isemail){
        message.error('Email required')
      }
      else{
     
     dispatch(forgetPassword({email:isemail}))
      }
      }


    return (
      <div>
       
         <Form 
      {...layout}
      name="basic"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: 'Please input your username!' }]}
      >
        <Input onChange={handleChange}/>
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password />
      </Form.Item>


<div style={{textAlign:'right', paddingBottom:'10px', cursor:'pointer'}}>
    <p onClick={handleClickEmail} >Forgot Password?</p>
    </div>
      <Form.Item {...tailLayout}>
        <button className="text-[#9a4c9d] bg-[#9a4c9d29] float-right border-[#9a4c9d] text-[16px] p-1 md:mr-0 sm:mr-0 mr-[20%] "  style={{fontWeight:'500'}} type="primary" htmlType="submit">
          Submit
        </button>
      </Form.Item>
    </Form>
  
   </div>
    )
}


// const LoginWrap = styled.div`


// .ant-form-item {
   
//     margin-bottom: 10px !important;
    
// }


// `